import { Form }                from 'antd';
import { Upload }              from 'antd';
import { Button }              from 'antd';
import { UploadOutlined }      from '@ant-design/icons';
import FormattedMessageWrapper from './FormattedMessageWrapper';

interface FormItemUploadProps {
  disabled?: boolean;
  label?: any;
  name: string;
  required?: boolean;
}

const FormItemUpload = ({ required = true, ...props }: FormItemUploadProps) => {
  const { disabled, label, name } = props;

  return (
    <Form.Item
      getValueFromEvent={e => {
        if (Array.isArray(e)) {
          return e;
        }

        return e && e.fileList;
      }}
      label={label}
      labelCol={{ span: 24 }}
      rules={[
        {
          message: <FormattedMessageWrapper id="Fichier manquant" />,
          required,
        },
        () => ({
          message: <FormattedMessageWrapper id="Un seul fichier autorisé" />,
          validator: (_, value) => {
            if (value.length > 1) {
              return Promise.reject();
            }

            return Promise.resolve();
          },
        }),
      ]}
      valuePropName="fileList"
      {...props}
      name={name}
      required={required}
    >
      <Upload
        beforeUpload={() => false}
        multiple={false}
      >
        <Button
          disabled={disabled}
          icon={<UploadOutlined />}
          style={{
            alignItems: 'center',
            display: 'flex',
            gap: '8px',
          }}
        >
          <FormattedMessageWrapper id="Joindre un fichier" />
        </Button>
      </Upload>
    </Form.Item>
  );
};

export default FormItemUpload;
